import React from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getNearestWorkingHours, isCurrentlyWorkingHours } from '../../utils/workScheduleUtils';

export const SuccessPopup: React.FC<{
  open: boolean;
  onClose: () => void;
  clinicName: string;
  workSchedule: any;
  type?: 'email' | 'manager';
}> = ({ open, onClose, clinicName, workSchedule, type = 'manager' }) => {
  const { startTime, endTime, dayName } = getNearestWorkingHours(workSchedule);
  const isWorking = isCurrentlyWorkingHours(workSchedule);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '359px',
          maxWidth: 'none',
          borderRadius: '20px',
          margin: 0,
          position: 'relative',
          overflow: 'hidden',
          bgcolor: '#FFFFFF'
        }
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1
        }}
      >
        <CloseIcon />
      </IconButton>

      <Box
        sx={{
          p: '20px 20px 24px 20px',
          minHeight: 'fit-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 2
        }}
      >
        <Box>
          {type === 'email' ? (
            <>
              <Typography
                sx={{
                  fontWeight: 600,
                  mb: '2px',
                  fontSize: '20px',
                  lineHeight: 1,
                  textAlign: 'left',
                  color: '#212121',
                  fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                }}
              >
                Данные для входа
              </Typography>

              <Typography
                sx={{
                  fontWeight: 600,
                  mb: '16px',
                  fontSize: '20px',
                  lineHeight: 1,
                  textAlign: 'left',
                  color: '#212121',
                  fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                }}
              >
                отправлены на почту!
              </Typography>

              <Typography
                sx={{
                  fontSize: '16px',
                  lineHeight: 1.2,
                  textAlign: 'left',
                  color: '#212121',
                  fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  fontWeight: 500,
                }}
              >
                Если письмо не пришло - напишите
              </Typography>

              <Typography
                sx={{
                  fontSize: '16px',
                  lineHeight: 1.2,
                  textAlign: 'left',
                  color: '#212121',
                  fontFamily: 'TikTok Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  fontWeight: 500,
                }}
              >
                менеджеру в чат
              </Typography>
            </>
          ) : isWorking ? (
            <>
              <Typography
                sx={{
                  fontWeight: 700,
                  mb: '12px',
                  fontSize: '20px',
                  lineHeight: 1.1,
                  textAlign: 'left',
                  pr: 3
                }}
              >
                Благодарим вас за обращение!
              </Typography>

              <Typography
                sx={{
                  fontSize: '16px',
                  lineHeight: 1.15,
                  textAlign: 'left',
                  color: '#212121',
                }}
              >
                Скоро менеджер свяжется с вами и предложит варианты для записи!
              </Typography>
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontWeight: 700,
                  mb: '12px',
                  fontSize: '20px',
                  lineHeight: 1.1,
                  textAlign: 'left',
                  pr: 3
                }}
              >
                Спасибо за ваше обращение в клинику {clinicName}
              </Typography>

              <Typography
                sx={{
                  fontSize: '16px',
                  lineHeight: 1.15,
                  textAlign: 'left',
                  color: '#212121',
                  mb: 1
                }}
              >
                Ваша заявка получена и передана менеджеру.
              </Typography>

              <Typography
                sx={{
                  fontSize: '16px',
                  lineHeight: 1.15,
                  textAlign: 'left',
                  color: '#212121'
                }}
              >
                Мы свяжемся с вами в рабочее время — {dayName} с {startTime} до {endTime} — и с радостью ответим на все вопросы.
              </Typography>
            </>
          )}
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={onClose}
          sx={{
            height: type === 'email' ? '58px' : '48px',
            borderRadius: type === 'email' ? '24px' : '14px',
            backgroundColor: '#007AFF',
            textTransform: 'none',
            fontSize: '16px',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#005FCC'
            }
          }}
        >
          Закрыть
        </Button>
      </Box>
    </Dialog>
  );
};
